<template>
  <sui-container>
    <sui-table>
    <sui-table-header>
      <sui-table-row>
        <sui-table-header-cell>Devices that can view your Trackers:</sui-table-header-cell>
        <sui-table-header-cell>Last Login</sui-table-header-cell>
        <sui-table-header-cell></sui-table-header-cell>
      </sui-table-row>
    </sui-table-header>
    <sui-table-body>
      <sui-table-row v-if="(data || []).length === 0">
        <sui-table-cell>No devices have been authorized yet</sui-table-cell>
      </sui-table-row>
      <sui-table-row v-for="item in data" :key="item.DeviceID">
        <sui-table-cell>
          <sui-popup basic content="This device can manage your account" v-if="item.ElevatedAccess">
            <sui-icon name="user circle" slot="trigger" class="margin-right"/>
          </sui-popup>
          <sui-popup basic content="Shared access - this device can only see your devices" v-else>
            <sui-icon name="user circle outline" slot="trigger"  style="visibility: hidden"/>
          </sui-popup>
          <editable-field :data="item.DeviceName" @change="nameChangeHandler($event, item)"></editable-field>
        </sui-table-cell>
        <sui-table-cell>
          <template v-if="item.LastLogin">
            {{item.LastLogin  | formatTime}} ({{item.LastLogin  | formatDifference}} ago)
          </template>
          <template v-else>
            Never
          </template>

        </sui-table-cell>
        <sui-table-cell :width="4">
          <sui-button compact basic color="pink" type="button" @click="revokeHandler(item)">Revoke Access</sui-button>
        </sui-table-cell>
      </sui-table-row>
      <!-- Add -->
      <sui-table-row v-if="$store.state.client.revokeError !== ''">
        <sui-table-cell colspan="3">
          <sui-message error>When revoking: {{$store.state.client.revokeError}}</sui-message>
        </sui-table-cell>
      </sui-table-row>
      <sui-table-row v-if="$store.state.client.updateError !== ''">
        <sui-table-cell colspan="3">
          <sui-message error>When updating: {{$store.state.client.updateError}}</sui-message>
        </sui-table-cell>
      </sui-table-row>
    </sui-table-body>
  </sui-table>
    <sui-table>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell>Share Trackers with new device</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>
        <sui-table-row>
          <sui-table-cell>
            Share Code &nbsp;
            <sui-input :maxlength="6" v-model="activationCode" @keyup.enter.native="addNew"></sui-input>&nbsp;&nbsp;
            <sui-popup basic content="This device can manage your account">
              <sui-checkbox label="Elevated Access" toggle v-model="elevatedAccess" slot="trigger"/>
            </sui-popup>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <sui-button basic color="pink" type="button" @click="addNew()" :disabled="activationCode.length !== 6">Share</sui-button>
            <sui-message v-if="elevatedAccess" warning>The device will be able to modify your account settings, including authorizing another mobile devices</sui-message>
            <sui-message error v-if="$store.state.client.authorizeError !== ''">{{$store.state.client.authorizeError}}</sui-message>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>
  </sui-container>
</template>

<script>
  import EditableField from "../EditableField";
  export default {
    name: "MobileClients",
    components: {EditableField},
    props: ["data"],
    data: function() {
      return {
        activationCode: "",
        elevatedAccess: false,
      }
    },
    methods: {
      async revokeHandler(device) {
        let confirmation = confirm(`Are you sure? Please press OK if you want to revoke access to ${device.DeviceName}.`);
        if (confirmation) {
          await this.$store.dispatch('client/revoke', device.ID)
          if (!this.$store.state.client.revokeError) {
            this.$store.dispatch('client/loadUserClients')
          }
        }
      },
      async addNew() {
        if ((this.activationCode || "").length == 6) {
          await this.$store.dispatch('client/authorize', {activationCode: this.activationCode, elevatedAccess:this.elevatedAccess});
          if (!this.$store.state.client.authorizeError) {
            this.activationCode = ""
            this.$store.dispatch('client/loadUserClients')
          }
        }
      },
      async nameChangeHandler(newValue, item) {
        await this.$store.dispatch('client/update', {ID: item.ID, Name: newValue})
        if (!this.$store.state.client.updateError) {
          this.$store.dispatch('client/loadUserClients')
        }

      }
    }
  }
</script>

<style scoped>
  .margin-right {
    margin-right: 10pt;
  }

</style>
